<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <!-- Page header -->
        <v-flex xs12>
          <div class="modern-page-header">
            <div class="modern-page-header__left">
              <div class="modern-page-header__icon-wrap">
                <v-icon class="modern-page-header__icon">policy</v-icon>
              </div>
              <div>
                <h3 class="modern-page-header__title">Manage Policies</h3>
                <p class="modern-page-header__sub">Create and assign access control policies</p>
              </div>
            </div>
            <div class="modern-page-header__actions">
              <v-btn depressed color="primary" class="modern-add-btn" @click="handleCreateNew">
                <v-icon left small>add</v-icon>Create Policy
              </v-btn>
            </div>
          </div>
        </v-flex>

        <!-- Create / Edit Policy dialog -->
        <v-dialog v-model="addPolicy" max-width="520px">
          <v-card class="policy-dialog">
            <div class="modal-header">
              <div class="modal-header__left">
                <div class="modal-header__icon-wrap">
                  <v-icon class="modal-header__icon">policy</v-icon>
                </div>
                <div>
                  <div class="modal-header__title">{{ policy._id ? 'Edit Policy' : 'Create Policy' }}</div>
                  <div class="modal-header__sub">Define a new access rule</div>
                </div>
              </div>
              <v-btn icon flat class="modal-close-btn" @click="addPolicy = false; policy = { policy: '' }">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider class="modal-divider"></v-divider>

            <div class="modal-body">
              <div class="form-field-label">Policy Description</div>
              <v-textarea
                v-model="policy.policy"
                outline
                placeholder="Describe this policy rule..."
                rows="4"
                class="policy-textarea"
                no-resize
              ></v-textarea>
            </div>

            <v-divider class="modal-divider"></v-divider>
            <div class="modal-footer">
              <v-btn flat class="modal-cancel-btn" @click="addPolicy = false; policy = { policy: '' }">
                Cancel
              </v-btn>
              <v-btn depressed color="primary" class="modal-action-btn" @click="createPolicy">
                <v-icon left small>{{ policy._id ? 'save' : 'add' }}</v-icon>
                {{ policy._id ? 'Update' : 'Create' }}
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- Policies table -->
        <v-flex lg12>
          <v-card class="modern-table-card">
            <div class="modern-table-toolbar">
              <div class="modern-search-wrap">
                <v-icon class="modern-search-icon">search</v-icon>
                <input v-model="search" class="modern-search-input" placeholder="Search policies..." />
              </div>
              <v-btn icon flat class="modern-toolbar-btn" title="Filter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </div>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                item-key="name"
                class="modern-data-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="table-cell-policy">{{ props.item.policy }}</td>
                  <td align="right" class="table-cell-actions">
                    <v-btn small flat color="info" class="table-action-btn" @click="assignPolicy(props.item)">
                      <v-icon left x-small>link</v-icon>Assign
                    </v-btn>
                    <v-btn small flat color="primary" class="table-action-btn" @click="handleMoreInfo(props.item)">
                      <v-icon left x-small>edit</v-icon>Edit
                    </v-btn>
                    <v-btn small flat color="error" class="table-action-btn" @click="handleDelete(props.index, props.item)">
                      <v-icon left x-small>delete</v-icon>Delete
                    </v-btn>
                  </td>
                </template>
                <template slot="no-data">
                  <div class="modern-empty-state">
                    <v-icon class="modern-empty-state__icon">policy</v-icon>
                    <p class="modern-empty-state__text">No policies created yet</p>
                    <v-btn depressed color="primary" small @click="handleCreateNew">Create First Policy</v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APIPolicies from "@/mixins/APIPolicies";
import ConfirmDelete from "@/mixins/confirmDelete";
export default {
  mixins: [APIPolicies, ConfirmDelete],
  data() {
    return {
      search: "",
      addPolicy: false,
      policy: { policy: "" },
      complex: {
        selected: [],
        headers: [
          { text: "Policy Description", value: "policy" },
          { text: "Actions", value: "", sortable: false }
        ],
        items: []
      }
    };
  },
  computed: {
    queriedUrlId() {
      let url = window.location.href.split("create/");
      return url[1];
    }
  },
  created() {
    this.restoreFrom();
    this.handleGet();
  },
  methods: {
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.companyId = this.$route.params.id;
      } else if (this.$route.params.object === undefined && this.queriedUrlId !== "0") {
        this.companyId = this.queriedUrlId;
      }
    },
    handleGet: async function() {
      try {
        this.complex.items = await this.getPolicies();
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", { position: "topCenter" });
      }
    },
    handleCreateNew: function() {
      this.policy = { policy: "" };
      this.addPolicy = true;
    },
    createPolicy: async function() {
      if (!this.policy.policy || this.policy.policy.length === 0) return;
      try {
        this.addPolicy = false;
        if (this.policy._id) {
          await this.putPolicie(this.policy);
        } else {
          await this.postPolicie(this.policy);
          this.policy = { policy: "" };
        }
        await this.handleGet();
        this.$toast.success("Success", "submitted", { position: "topCenter" });
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", { position: "topCenter" });
      }
    },
    handleMoreInfo: function(row) {
      this.policy = row;
      this.addPolicy = true;
    },
    handleDelete: async function(index, row) {
      let tempTableData = this.complex.items;
      const result = await this.confirmDeleteAction({
        title: "Delete this policy?",
        text: "This action cannot be undone.",
        confirmButtonText: "Delete Policy"
      });
      if (!result || !result.value) return;
      let userId = row._id;
      await this.deleteRow(tempTableData, index, userId);
      this.$toast.success("Policy deleted successfully.", "Success", { position: "topCenter" });
    },
    deleteRow: async function(tempTableData, index, id) {
      if (index >= 0) {
        this.complex.items = tempTableData.filter(obj => obj._id != id);
        try {
          await this.deletePolicie(id);
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", { position: "topCenter" });
        }
      }
    },
    assignPolicy: function(policy) {
      this.$router.push({ name: "Assigning Policies", params: { policy: policy } });
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 0 20px; flex-wrap: wrap; gap: 16px;
}
.modern-page-header__left { display: flex; align-items: center; gap: 16px; }
.modern-page-header__icon-wrap {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #7C3AED, #5B21B6);
  display: flex; align-items: center; justify-content: center;
}
.modern-page-header__icon { color: #ffffff !important; font-size: 22px !important; }
.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 1.3rem;
  font-weight: 700; color: #1e293b; margin: 0; letter-spacing: -0.3px;
}
.modern-page-header__sub { font-family: 'Inter', 'Roboto', sans-serif; font-size: 13px; color: #64748b; margin: 2px 0 0; }
.modern-page-header__actions { display: flex; gap: 8px; }
.modern-add-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 600 !important;
  text-transform: none !important; border-radius: 10px !important;
  height: 40px !important; padding: 0 18px !important;
}

/* Dialog */
.policy-dialog { border-radius: 16px !important; overflow: hidden; }
.modal-header {
  display: flex; align-items: center; justify-content: space-between; padding: 20px 20px 16px;
}
.modal-header__left { display: flex; align-items: center; gap: 14px; }
.modal-header__icon-wrap {
  width: 42px; height: 42px; border-radius: 12px;
  background: linear-gradient(135deg, #7C3AED, #5B21B6);
  display: flex; align-items: center; justify-content: center;
}
.modal-header__icon { color: #ffffff !important; font-size: 20px !important; }
.modal-header__title { font-family: 'Inter', 'Roboto', sans-serif; font-size: 16px; font-weight: 700; color: #1e293b; }
.modal-header__sub { font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; color: #94a3b8; margin-top: 2px; }
.modal-close-btn { color: #94a3b8 !important; }
.modal-divider { border-color: #f1f5f9 !important; }
.modal-body { padding: 20px; }
.form-field-label { font-family: 'Inter', 'Roboto', sans-serif; font-size: 13px; font-weight: 600; color: #475569; margin-bottom: 6px; }
.policy-textarea >>> .v-input__slot { background: #f8fafc !important; border-radius: 10px !important; }
.modal-footer { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 14px 20px; }
.modal-cancel-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; color: #64748b !important; border-radius: 10px !important;
}
.modal-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 600 !important;
  text-transform: none !important; border-radius: 10px !important;
  height: 40px !important; padding: 0 20px !important;
  box-shadow: 0 2px 8px rgba(124,58,237,0.3) !important;
}

/* Table */
.modern-table-card { border-radius: 14px !important; overflow: hidden; }
.modern-table-toolbar { display: flex; align-items: center; padding: 14px 16px; gap: 8px; }
.modern-search-wrap {
  flex: 1; display: flex; align-items: center;
  background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;
  padding: 8px 14px; gap: 10px; transition: border-color 0.2s ease;
}
.modern-search-wrap:focus-within { border-color: #7C3AED; background: #ffffff; }
.modern-search-icon { color: #94a3b8 !important; font-size: 18px !important; }
.modern-search-input {
  border: none; outline: none; background: transparent;
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 14px; color: #334155; width: 100%;
}
.modern-search-input::placeholder { color: #94a3b8; }
.modern-toolbar-btn { color: #64748b !important; }

.table-cell-policy { color: #334155 !important; font-size: 14px !important; line-height: 1.5; }
.table-cell-actions { white-space: nowrap; }
.table-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; border-radius: 7px !important;
  height: 30px !important; min-width: unset !important;
  padding: 0 10px !important; font-size: 12px !important; margin: 0 2px !important;
}
.modern-empty-state {
  padding: 60px 24px; text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: 12px;
}
.modern-empty-state__icon { font-size: 48px !important; color: #cbd5e1 !important; }
.modern-empty-state__text { font-family: 'Inter', 'Roboto', sans-serif; font-size: 15px; color: #94a3b8; margin: 0; }
</style>
